var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroImgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 54,
    viewBox: "0 0 57 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5552 52.3574C43.3545 52.3574 55.3517 41.0935 55.3517 27.1988C55.3517 13.304 43.3545 2.0401 28.5552 2.0401C13.7558 2.0401 1.75854 13.304 1.75854 27.1988C1.75854 41.0935 13.7558 52.3574 28.5552 52.3574Z",
    fill: "",
    stroke: "#1A1A1A",
    strokeWidth: 2.98953,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3201 13.3639H15.3549V17.3135H41.3201V13.3639Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3201 25.5789H15.3549V29.5284H41.3201V25.5789Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3201 37.084H15.3549V41.0335H41.3201V37.084Z",
    fill: "#1C0311",
    stroke: "#1A1A1A",
    strokeWidth: 1.49476,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroImgMenu);
export default __webpack_public_path__ + "static/media/hero-img-menu.df0369cbc88684e0f465b1ed5a18a94f.svg";
export { ForwardRef as ReactComponent };